import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { combineLatest, filter, map, take } from "rxjs";
import { sessionFeature } from "../../authentication/store/session.reducer";

export const clientOwnerAccessGuard: CanActivateFn = () => {
    const store = inject(Store);
    const router = inject(Router);
    return combineLatest([
        store.select(sessionFeature.selectIsSettled),
        store.select(sessionFeature.selectUser),
    ]).pipe(
        filter(([settled]) => settled),
        take(1),
        map(([, user]) =>
            user?.roles.includes("client_owner")
                ? true
                : router.createUrlTree(["/dashboard"])
        )
    );
};
